"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spanModifiers = exports.spanModifiersConfig = exports.offsetModifiers = exports.offsetModifiersConfig = void 0;

var _styledComponents = require("styled-components");

var _styledComponentsModifiers = require("styled-components-modifiers");

var offsetModifiersConfig = {
  '1': function _() {
    return (0, _styledComponents.css)(["margin-left:8.33333333%;"]);
  },
  '2': function _() {
    return (0, _styledComponents.css)(["margin-left:16.66666667%;"]);
  },
  '3': function _() {
    return (0, _styledComponents.css)(["margin-left:25%;"]);
  },
  '4': function _() {
    return (0, _styledComponents.css)(["margin-left:33.33333333%;"]);
  },
  '5': function _() {
    return (0, _styledComponents.css)(["margin-left:41.66666667%;"]);
  },
  '6': function _() {
    return (0, _styledComponents.css)(["margin-left:50%;"]);
  },
  '7': function _() {
    return (0, _styledComponents.css)(["margin-left:58.33333333%;"]);
  },
  '8': function _() {
    return (0, _styledComponents.css)(["margin-left:66.66666667%;"]);
  },
  '9': function _() {
    return (0, _styledComponents.css)(["margin-left:75%;"]);
  },
  '10': function _() {
    return (0, _styledComponents.css)(["margin-left:83.33333333%;"]);
  },
  '11': function _() {
    return (0, _styledComponents.css)(["margin-left:91.66666667%;"]);
  }
};
exports.offsetModifiersConfig = offsetModifiersConfig;
var offsetModifiers = (0, _styledComponentsModifiers.applyStyleModifiers)(offsetModifiersConfig, 'offset');
exports.offsetModifiers = offsetModifiers;
var spanModifiersConfig = {
  '0': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:0;flex-basis:0;flex-grow:0;"]);
  },
  '1': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%;"]);
  },
  '2': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%;"]);
  },
  '3': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%;"]);
  },
  '4': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%;"]);
  },
  '5': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%;"]);
  },
  '6': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%;"]);
  },
  '7': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%;"]);
  },
  '8': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%;"]);
  },
  '9': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%;"]);
  },
  '10': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%;"]);
  },
  '11': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%;"]);
  },
  '12': function _() {
    return (0, _styledComponents.css)(["-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%;"]);
  }
};
exports.spanModifiersConfig = spanModifiersConfig;
var spanModifiers = (0, _styledComponentsModifiers.applyStyleModifiers)(spanModifiersConfig, 'span');
exports.spanModifiers = spanModifiers;